import Image from "next/image";
import { cdnBaseURL } from '@/commons/constants';

const CategoriesImageBox = ({
                              name,
                              categoryid,
                              imageUrl,
                              altText,
                              onClick,
                            }) => {
  return (
    <div className="flex items-center justify-center relative cursor-pointer transition-transform duration-200 hover:scale-105">
      <div className="relative w-[104px] h-[136px] sm:w-[120px] sm:h-[150px] md:w-[140px] md:h-[170px] lg:w-[200px] lg:h-[200px] xl:w-[260px] xl:h-[260px] overflow-hidden rounded-xl shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out">
        {/* Main Image */}
        <div
          className="relative w-full h-full"
          onClick={() => onClick(categoryid)}
        >
          <Image
            src={imageUrl?.replace("bmpassets.s3.ap-south-1.amazonaws.com",cdnBaseURL)}
            alt={altText}
            fill
            sizes="(max-width: 640px) 104px, (max-width: 768px) 120px, (max-width: 1024px) 140px, (max-width: 1280px) 200px, 260px"
            className="object-cover"
            priority={false}
          />
        </div>

        {/* Text Overlay with Gradient */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 via-black/50 to-transparent p-2 sm:p-2.5 md:p-3 lg:p-4">
          <span className="flex items-center justify-center text-white font-medium text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl text-center leading-tight">
            {name.replace(/-/g, " ")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CategoriesImageBox;